import { useState } from 'react';

import WeeklyPredictionsTabs from './WeeklyPredictionsTabs';
import MonthlyPredictionsTabs from './MonthlyPredictionsTabs';

export const PredictionsPage = () => {
  const [activePrediction, setActivePrediction] = useState<'weekly' | 'monthly'>('weekly');

  const [activeWeek, setActiveWeek] = useState<'current' | 'next'>('current');

  return (
    <div className="space-y-8 view-table-only">
      <div className="flex justify-center gap-4 flex-wrap">
        <button
          onClick={() => setActivePrediction('weekly')}
          className={`
            font-20
            w-full sm:w-auto
            h-10
            px-5
            font-semibold
            font-spectral
            uppercase
            rounded-lg
            flex
            justify-center
            items-center
            cursor-pointer
            inner-shadow-blue
            transition-all
            duration-500
            ease-in-out
            ${
              activePrediction === 'weekly'
                ? 'bg-[linear-gradient(to_right,#082261,#34065c)] text-white'
                : 'bg-white text-black hover:bg-[linear-gradient(to_right,#082261,#34065c)] hover:text-white'
            }
          `}
        >
          Weekly Predictions
        </button>

        <button
          onClick={() => setActivePrediction('monthly')}
          className={`
            font-20
            w-full sm:w-auto
            h-10
            px-5
            font-semibold
            font-spectral
            uppercase
            rounded-lg
            flex
            justify-center
            items-center
            cursor-pointer
            inner-shadow-blue
            transition-all
            duration-500
            ease-in-out
            ${
              activePrediction === 'monthly'
                ? 'bg-[linear-gradient(to_right,#082261,#34065c)] text-white'
                : 'bg-white text-black hover:bg-[linear-gradient(to_right,#082261,#34065c)] hover:text-white'
            }
          `}
        >
          Monthly Predictions
        </button>
      </div>

      {activePrediction === 'weekly' && (
        <div className="space-y-8 rounded-xl  font-lato">
          <WeeklyPredictionsTabs activeWeek={activeWeek} setActiveWeek={setActiveWeek} />
        </div>
      )}

      {activePrediction === 'monthly' && (
        <div className="space-y-8 rounded-xl  font-lato">
          <MonthlyPredictionsTabs />
        </div>
      )}
    </div>
  );
};
